import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { ArcadeWheelEvent } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
import { SpinsState } from "@lib/titan2-slingo/dist/game/view/abstract/display/SpinsRemaining";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { gsap } from "gsap";
import { GameEvent, SpinsRemainingViewEvent } from "../../../controller/event/GameEvent";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
/**
 * GameSpinsRemaining.ts
 */
export class GameSpinsRemaining extends AbstractGameView {
    handleSpinResult() {
        if (this.state === SpinsState.FREE) {
            return;
        }
        const textField = this.state === SpinsState.STANDARD ? this.standard : this.purchase;
        const updater = this.state === SpinsState.STANDARD ? this.updateStandard : this.updatePurchase;
        const currentTextFieldValue = parseInt(textField.getText(), 10);
        if (currentTextFieldValue == 0) {
            console.warn("attempt to set -ve spin amount");
        }
        else {
            updater.call(this, currentTextFieldValue - 1);
        }
    }
    updateSpinsRemaining() {
        const game = this.model.getGameProgress();
        const spinsRemaining = game.getSpinsRemaining();
        this.updateStandard(spinsRemaining);
        this.updatePurchase(this.responsibleGaming.getPurchaseSpinsRemaining());
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
    }
    create() {
        super.create();
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        this.standard = TitanText.createField(this, this.landscapeProperties.standardProperties, this.portraitProperties?.standardProperties);
        this.inactiveStandard = TitanText.createField(this, this.landscapeProperties.standardProperties, this.portraitProperties?.standardProperties);
        this.purchase = TitanText.createField(this, this.landscapeProperties.purchaseProperties, this.portraitProperties?.purchaseProperties);
        this.inactiveStandard.alpha = 0.7;
        this.background.setTrackingId(SlingoStyle.REMAINING_SPINS);
    }
    postCreate() {
        super.postCreate();
        this.standard.visible = true;
        this.purchase.visible = this.inactiveStandard.visible = false;
        this.updatePurchase(this.responsibleGaming.getPurchaseSpinsRemaining());
        this.state = SpinsState.START;
        Logger.addObjectRef(this, "SpinsRemaining");
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(CommonGameEvent.SPIN, this.handleStandardSpin);
        this.registerGame(CommonGameEvent.FREE_SPIN, this.handleFreeSpin);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN, this.handlePurchaseSpin);
        this.registerGame(SlingoEvent.GAME_SUMMARY, this.handleGameSummary);
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.handleStandardSpinRecovery);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.handleFreeSpinRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.handlePurchaseSpinRecovery);
        this.registerGame(SlingoEvent.SPIN_RESULT, this.handleSpinResult);
        this.registerGame(SlingoEvent.REELS_COMPLETE, this.handleReelsComplete);
        this.registerGame(CommonGameEvent.REPLAY_PURCHASE_ENTRY, this.handleReplayPurchaseEntry);
        this.registerGame(ArcadeWheelEvent.SHOW, this.handleArcadeWheelShow);
        this.registerGame(ArcadeWheelEvent.HIDE, this.handleArcadeWheelHide);
        this.registerGame(ArcadeWheelEvent.WIN, this.handleArcadeWheelHide);
        this.registerGame(ArcadeWheelEvent.REPLAY_SPIN_COMPLETE, this.handleArcadeWheelReplaySpinComplete);
        this.registerGame(SpinsRemainingViewEvent.FREE_SPIN_REELS_START, this.freeSpinReelStart);
        this.registerGame(SpinsRemainingViewEvent.FREE_SPIN_REELS_END, this.freeSpinReelEnd);
        this.registerGame(GameEvent.FREE_SPIN_REELS_RECOVER, this.handleFreeSpinReelsRecover);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(GameSpinesRemainingEvents.TRANSITION_TO_FEATURE_FADE_OUT, this.handleTransitionToFeatureFadeOut);
        this.registerGame(GameSpinesRemainingEvents.TRANSITION_FROM_FEATURE_FADE_IN, this.handleTransitionFromFeatureFadeIn);
    }
    handleTransitionToFeatureFadeOut() {
        gsap.to(this, { alpha: 0 });
    }
    handleTransitionFromFeatureFadeIn() {
        this.visible = true;
        this.alpha = 0;
        gsap.to(this, { alpha: 1 });
    }
    handleFreeSpinReelsRecover() {
        this.updateSpinsRemaining();
    }
    freeSpinReelStart() {
        this.changeState(SpinsState.FREE);
    }
    freeSpinReelEnd() {
        const isReplayedPurchase = Service.isReplay() && (this.model.getGameProgress().getPurchaseSpinsUsed() > 0);
        this.changeState(isReplayedPurchase ? SpinsState.PURCHASE : SpinsState.STANDARD);
    }
    handleReplayPurchaseEntry() {
        console.log("[SpinsRemaining] - handleReplayPurchaseEntry()");
        this.updateSpinsRemaining();
        this.handleStandardSpin();
    }
    handlePurchaseEntry() {
        const config = this.model.getGameConfig();
        this.updateStandard(config.getNumberOfSpins());
        this.handleStandardSpin();
    }
    handleStandardSpin() {
        const isReplayedPurchase = Service.isReplay() && (this.model.getGameProgress().getPurchaseSpinsUsed() > 0);
        ;
        this.changeState(isReplayedPurchase ? SpinsState.PURCHASE : SpinsState.STANDARD);
    }
    handlePurchaseSpin() {
        this.changeState(SpinsState.PURCHASE);
    }
    handleFreeSpin() {
        this.changeState(SpinsState.FREE);
    }
    handleGameSummary() {
        this.handleArcadeWheelHide();
    }
    changeState(state) {
        const change = state !== this.state;
        this.state = state;
        if (change) {
            this.standard.visible = this.purchase.visible = this.inactiveStandard.visible = false;
            switch (state) {
                case SpinsState.STANDARD:
                    this.standard.visible = true;
                    break;
                case SpinsState.PURCHASE:
                    this.purchase.visible = true;
                    break;
                case SpinsState.FREE:
                    const isPurchaseSpin = !!this.model.getGameProgress().getPurchaseSpinsUsed();
                    this.standard.visible = !isPurchaseSpin;
                    this.purchase.visible = isPurchaseSpin;
                    break;
            }
        }
    }
    stateRecovery(state) {
        this.changeState(state);
        switch (state) {
            case SpinsState.STANDARD:
                break;
            case SpinsState.PURCHASE:
                break;
            case SpinsState.FREE:
                break;
        }
    }
    handleResponsibleGamingLimit() {
        this.handlePurchaseSpin();
        this.updateSpinsRemaining();
    }
    handleStandardSpinRecovery() {
        this.stateRecovery(SpinsState.STANDARD);
        this.updateSpinsRemaining();
    }
    handleFreeSpinRecovery() {
        this.stateRecovery(SpinsState.FREE);
        this.updateSpinsRemaining();
    }
    handlePurchaseSpinRecovery() {
        this.stateRecovery(SpinsState.PURCHASE);
        this.updateSpinsRemaining();
    }
    handleArcadeWheelReplaySpinComplete() {
        if (Service.isReplay()) {
            this.updateSpinsRemaining();
        }
    }
    handleReelsComplete() {
        this.updateSpinsRemaining();
    }
    handleArcadeWheelShow() {
        this.purchase.alpha = 0.5;
    }
    handleArcadeWheelHide() {
        this.purchase.alpha = 1.0;
    }
    updateText(textObj, text) {
        const change = parseInt(text) !== parseInt(textObj.getText());
        if (!change) {
            return;
        }
        const increment = parseInt(text) > parseInt(textObj.getText());
        if (increment) {
            // this.flowerSpine.play("1-value-increase", false, false, 1);
        }
        else {
            // this.flowerSpine.play("1-value-decrease", false, false, 1);
        }
        textObj.setText(text);
    }
    updateStandard(value) {
        this.updateText(this.standard, String(value));
        this.updateText(this.inactiveStandard, String(value));
    }
    updatePurchase(value) {
        let text = String(value);
        if (value > 100) {
            text = "∞";
        }
        this.updateText(this.purchase, text);
    }
}
export class GameSpinesRemainingEvents {
}
GameSpinesRemainingEvents.TRANSITION_TO_FEATURE_FADE_OUT = new EventObject("GameSpinesRemainingEvents.TRANSITION_TO_FEATURE_FADE_OUT");
GameSpinesRemainingEvents.TRANSITION_FROM_FEATURE_FADE_IN = new EventObject("GameSpinesRemainingEvents.TRANSITION_FROM_FEATURE_FADE_IN");
//# sourceMappingURL=GameSpinsRemaining.js.map